import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { AvatarModule } from "primeng/avatar";
import { AvatarGroupModule } from "primeng/avatargroup";
import { ButtonModule } from "primeng/button";
import { ImageModule } from "primeng/image";
import { InputTextareaModule } from "primeng/inputtextarea";
import { MenuModule } from "primeng/menu";
import { PaginatorModule } from "primeng/paginator";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { RatingModule } from "primeng/rating";
import { ScrollTopModule } from "primeng/scrolltop";
import { TableModule } from "primeng/table";
import { TooltipModule } from "primeng/tooltip";
import { PipesModule } from "../pipes/pipes.module";
import { AddReviewComponent } from "./add-review/add-review.component";
import { AgeRestrictionComponent } from "./age-restriction/age-restriction.component";
import { EditAddressComponent } from "./edit-address/edit-address.component";
import { FieldWithLabelComponent } from "./field-with-label/field-with-label.component";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { LoadingComponent } from "./loading/loading.component";
import { ProductComponent } from "./product/product.component";
import { StockIndicatorComponent } from "./stock-indicator/stock-indicator.component";
import { SubscribeComponent } from "./subscribe/subscribe.component";
import { SystemMessageComponent } from "./system-message/system-message.component";
import { TableComponent } from "./table/table.component";

@NgModule({
	declarations: [HeaderComponent, FooterComponent, SubscribeComponent, ProductComponent, LoadingComponent, EditAddressComponent, FieldWithLabelComponent, AgeRestrictionComponent, TableComponent, StockIndicatorComponent, AddReviewComponent, SystemMessageComponent],
	imports: [CommonModule, RouterModule, ReactiveFormsModule, FormsModule, ProgressSpinnerModule, TableModule, TooltipModule, ButtonModule, PipesModule, AvatarModule, AvatarGroupModule, PaginatorModule, MenuModule, InputTextareaModule, RatingModule, ScrollTopModule, ImageModule],
	exports: [HeaderComponent, FooterComponent, ProductComponent, LoadingComponent, FieldWithLabelComponent, TableComponent, StockIndicatorComponent],
})
export class ComponentsModule {}
